import React from 'react';

export default class FavoriteIcon extends React.Component {
  render() {
    return (
      <svg
        className='result-footer-icon favorite-icon'
        xmlns='http://www.w3.org/2000/svg'
        viewBox='-1093.271 1833 14.088 14'
      >
        <path
          d='M10.991,0h-.6a3.721,3.721,0,0,0-3.3,1.763A3.976,3.976,0,0,0,3.8,0H3.2C1.8.207.2,1.452,0,4.044v.83C.2,7.259,1.9,10.267,7.094,14c5.1-3.733,6.894-6.741,6.994-9.126v-.83C13.888,1.452,12.29.207,10.991,0Z'
          transform='translate(-1093.271 1833)'
        />
      </svg>
    );
  }
}
